import React, { useEffect, useState, useRef } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase";

export const getAnnualMaskDoctorEmailStatus = (item = {}) => {
  const state = item.doctorEmailStatus || (item.doctorEmailSent ? "sent" : "not_sent");
  const label = { sent: "Sent", queued: "Queued", processing: "Sending", failed: "Failed", delivery_unknown: "Delivery unconfirmed", not_sent: "Not sent" }[state] || "Unknown";
  const value = item.doctorEmailSentAt;
  const date = value && (typeof value.toDate === "function" ? value.toDate() : new Date(value));
  const sentDate = date && !Number.isNaN(date.getTime()) ? date.toLocaleString("en-GB", { timeZone: "Asia/Bangkok", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "";
  return { state, label, sentDate };
};

export default function AnnualMaskDoctorEmailStatus({ caseItem = {}, onChange }) {
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  const [live, setLive] = useState(null);
  const [unavailable, setUnavailable] = useState(false);
  useEffect(() => {
    setLive(null);
    setUnavailable(false);
    if (!caseItem.refPath || !["queued", "processing"].includes(caseItem.doctorEmailStatus)) return undefined;
    // Watch only a pending send; stop as soon as it reaches a delivery result.
    const unsubscribe = onSnapshot(doc(db, caseItem.refPath), (snapshot) => {
      if (!snapshot.exists()) return;
      const item = snapshot.data();
      setLive(item);
      if (onChangeRef.current) {
        const fields = {};
        ["status", "doctorEmailStatus", "doctorEmailRequestId", "doctorEmailQueuedAt", "doctorEmailSent", "doctorEmailSentAt", "doctorEmailSentTo", "doctorEmailSentBy"].forEach((key) => {
          if (item[key] !== undefined) fields[key] = item[key];
        });
        onChangeRef.current(fields);
      }
      if (!["queued", "processing"].includes(item.doctorEmailStatus)) unsubscribe();
    }, () => setUnavailable(true));
    return unsubscribe;
  }, [caseItem.refPath, caseItem.doctorEmailRequestId, caseItem.doctorEmailStatus]);
  const status = getAnnualMaskDoctorEmailStatus(live || caseItem);
  return <div className="small my-2">
    <b>Doctor Email Status: </b>
    <span className={`badge ${status.state === "sent" ? "badge-success" : ["failed", "delivery_unknown"].includes(status.state) ? "badge-warning" : "badge-secondary"}`}>{status.label}</span>
    {status.sentDate && <span className="text-muted ml-2">Last sent: {status.sentDate} (Bangkok)</span>}
    {unavailable && <span className="text-muted ml-2">Refresh to check delivery status.</span>}
  </div>;
}
